import React from "react";
import {
  DialogCloseIcon,
  DialogTitleAlignment,
  DialogTitleStyle,
} from "./CommonDialog.style";
import CloseIcon from "@mui/icons-material/Close";

interface DialogTitleProps {
  children?: React.ReactNode;
  onClose: () => void;
  titleAlignment?: "center" | "left" | "right" | string;
}

function CommonDialogTitle(props: DialogTitleProps) {
  const { children, onClose, titleAlignment, ...other } = props;
  return (
    <DialogTitleStyle sx={{ m: 0, p: 2 }} {...other}>
      <DialogTitleAlignment titleAlignment={titleAlignment}>
        {children}
      </DialogTitleAlignment>
      {onClose ? (
        <DialogCloseIcon aria-label="close" onClick={onClose}>
          <CloseIcon />
        </DialogCloseIcon>
      ) : null}
    </DialogTitleStyle>
  );
}

export default CommonDialogTitle;
